import React, { useContext, useEffect, useRef } from "react";

import stylesText from "../../components/Text/Text.module.scss";
import styles from "./About.module.scss";
import PathContext from "../../context/path";
import CoverAbout from '../../components/CoverAbout';
import Figure from '../../components/Figure';
import Factoid from '../../components/Factoid';
import Map from '../../components/Map';
import Sticky from '../../components/Sticky';
import StickyGallery from '../../components/StickyGallery';
import Photo from '../../components/Photo';
import Invite from '../../components/Invite';
import Footer from '../../components/Footer';
const About = () => {
  const path = useContext(PathContext);
  const refSpecials = useRef(null);
  const refPrivileges = useRef(null);
  const refFactoids = useRef(null);
  const refLove = useRef(null);
  useEffect(() => {

    window.scrollTo(0, 0);
    const specials = refSpecials.current;
    const factoids = refFactoids.current;
    const love = refLove.current;
    let options = {
      threshold: 0,
      rootMargin: '0% 0% -10% 0%'
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.animate);
          observer.unobserve(entry.target);
        }
      })
    }, options);
    observer.observe(specials);
    observer.observe(factoids);
    observer.observe(love);
    return () => {
      observer.unobserve(specials);
      observer.unobserve(factoids);
      observer.unobserve(love);
    }
  }, []);
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.cover} data-header-trigger={true}>
          <CoverAbout />
        </div>
        <section className={styles.specials} ref={refSpecials}>
          <div className="container">
            <div className={styles.specials__row}>
              <div className={styles.specials__text}>Специализируемся</div>
              <div className={`${styles.special} ${styles.special_1}`}>
                <Figure color={'pink'} form={'rect'}>
                  на исследованиях,
                </Figure>
              </div>
              <div className={`${styles.special} ${styles.special_2}`}>
                <Figure color={'green_light'}>
                  разработке,
                </Figure>
              </div>

            </div>
            <div className={styles.specials__row}>
              <div className={`${styles.special} ${styles.special_3}`}>
                <Figure bg={'transparent-saw-about.svg'}>
                  производстве
                </Figure>
              </div>
              <div className={`${styles.special} ${styles.special_4}`}>
                <Figure color={'green_light'}>
                  и поставке препаратов
                </Figure>
              </div>
              <div className={`${styles.special} ${styles.special_5}`}>
                <Figure color={'green_light'}>
                  и поставкe
                </Figure>
              </div>
              <div className={`${styles.special} ${styles.special_6}`}>
                <Figure color={'green_light'}>
                  препаратов
                </Figure>
              </div>
              <div className={`${styles.special} ${styles.special_7}`}>
                <Figure bg={"transparent-saw-square.svg"} rotate={'fade-in-up'}>
                </Figure>
              </div>
            </div>

            <div className={` ${styles.paragraph_1} ${stylesText.lid} ${stylesText.paragraph} ${stylesText.paragraph_about}  `} data-animate={'fade-in-up'}>
              <p>История Р‑Фарм началась в 2001 году с команды из пяти человек и маленького офиса. Мы постоянно росли и со временем превратились в международный бизнес с тысячами сотрудников и десятком производственных площадок. И все ещё продолжаем развиваться.</p>
              <p>Сейчас мы работаем по всей России, а ещё — в Германии, США, Вьетнаме, Азербайджане, Казахстане, Кыргызстане и Беларуси. Опыт работы в Р‑Фарм ценится не только в России, но и за рубежом. Лучше всего о нас расскажут факты:</p>
            </div>

            <div className={styles.factoids} ref={refFactoids}>
              <div className={styles.factoids__row}>
                <div className={styles.factoid}>
                  <Factoid color={'green'} title={['2001', null, 'C']} text={'года\nна фармрынке'} />
                </div>
                <div className={styles.factoid}>
                  <Factoid color={'green'} title={['5 000+']} text={'человек\nв команде'} />
                </div>
                <div className={styles.factoid}>
                  <Factoid color={'green'} title={['11']} text={'производственных\nплощадок'} />
                </div>
                <div className={styles.factoid}>
                  <Factoid color={'green'} title={['10 000+']} text={'наименований\nпродукции'} />
                </div>
                {/* </div>
              <div className={styles.factoids__row}> */}

                <div className={styles.factoid}>
                  <Factoid color={'green'} title={['140+']} text={'позиций медтехники\nв портфеле'} />
                </div>
                {/* <div className={styles.factoid}>
                  <Factoid color={'green'} title={['№1']} text={'на российском\nфармрынке,\n'} link={['по версии Forbes', 'https://www.forbes.ru/biznes/438965-20-lucsih-farmkompanij-rossii-2021-rejting-forbes']} />
                </div> */}

                <div className={styles.factoid}>
                  <Factoid color={'green'} title={['120+']} text={'препаратов в портфеле'} />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.map}>
          <Map />
        </section>
        <section className={styles.stable}>
          <div className="container">
            <h2 className={styles.stable__title}>Мы стабильные</h2>
            <div className={`${stylesText.lid} ${stylesText.paragraph} ${stylesText.paragraph_about}  ${styles.paragraph_2} `} data-animate={'fade-in-up'}>
              <p>За 25 лет работы пережили не один кризис и знаем, как справляться со сложностями и заботиться о сотрудниках в любые времена.</p>
            </div>
            <div className={`${styles.paragraph_3}  ${stylesText.paragraph} ${stylesText.paragraph_about}  `} data-animate={'fade-in-up'}>
              <h3>Льготы и привилегии</h3>
              <p>Гарантируем каждому сотруднику прозрачные условия работы — понятный и простой расчет вознаграждения в соответствии с лучшими практиками отрасли. У нас есть:</p>
            </div>

            <div className={styles.privileges} ref={refPrivileges} data-animate={true} data-animate-mobile={'fade-in-up'}>
              <div className={styles.privileges__inner}>
                <div className={styles.privilege} data-animate={'fade-in-up'} data-animate-mobile={'none'} data-animate-delay={'0'}>
                  <div className={styles.privilege__img}>
                    <img src={`${path}/img/about-privilege-1.svg`} alt="" />
                  </div>
                  <div className={styles.privilege__text}>ДМС</div>
                </div>
                <div className={styles.privilege} data-animate={'fade-in-up'} data-animate-mobile={'none'} data-animate-delay={'0.1'}>
                  <div className={styles.privilege__img}>
                    <img src={`${path}/img/about-privilege-2.svg`} alt="" />
                  </div>
                  <div className={styles.privilege__text}>Система гибких льгот</div>
                </div>
                <div className={styles.privilege} data-animate={'fade-in-up'} data-animate-mobile={'none'} data-animate-delay={'0.2'}>
                  <div className={styles.privilege__img}>
                    <img src={`${path}/img/about-privilege-3.svg`} alt="" />
                  </div>
                  <div className={styles.privilege__text}>Программа корпоративных привилегий</div>
                </div>
                {/* <div className={styles.privilege} data-animate={'fade-in-up'} data-animate-mobile={'none'} data-animate-delay={'0.3'}>
                  <div className={styles.privilege__img}>
                    <img src={`${path}/img/about-privilege-4.svg`} alt="" />
                  </div>
                  <div className={styles.privilege__text}>Надбавки за стаж</div>
                </div> */}
                <div className={styles.privilege} data-animate={'fade-in-up'} data-animate-mobile={'none'} data-animate-delay={'0.4'}>
                  <div className={styles.privilege__img}>
                    <img src={`${path}/img/about-privilege-5.svg`} alt="" />
                  </div>
                  <div className={styles.privilege__text}>Подарки для сотрудников</div>
                </div>
              </div>
            </div>

            <div className={`${stylesText.paragraph} ${stylesText.paragraph_about}  ${styles.paragraph_4} `} data-animate={'fade-in-up'}>
              <h3>Широкий портфель препаратов и медтехники</h3>
              <p>Позволяет Р‑Фарм хорошо себя чувствовать при любом положении дел на рынке, а сотрудникам — по максимуму проявлять свои способности и навыки.</p>
            </div>
            <div className={styles.scheme} data-animate={'fade-in-up'} data-animate-length={'30%'} data-animate-offset={'0%'} data-animate-duration={'2'} data-animate-ease={'cubic-bezier(.01,-0.01,0,1)'}>
              <div className={styles.scheme__left}>
                {/* <div className={styles.scheme__bg}>
                  <svg width="339" height="375" viewBox="0 0 339 375" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M47 359.006L47 374.004M47 359.006V365.504M47 359.006C47 352.379 41.6257 347.006 34.9982 347.006H13.0018C6.37436 347.006 1 341.634 1 335.006L1 12.9998C1 6.37241 6.37259 0.999823 13 0.999826L326 1C332.627 1 338 6.37259 338 13L338 335.006C338 341.634 332.627 347.006 326 347.006L59 347.006C52.3726 347.006 47 352.379 47 359.006Z" stroke="#003333" />
                  </svg>
                </div> */}
                <div className={styles.scheme__title}>Препараты</div>
                <ul className={styles.scheme__list}>
                  <li>Вирусология: ВИЧ, гепатит, коронавирусная инфекция</li>
                  <li>Онкология</li>
                  <li>Ревматология и иммунология</li>
                  <li>Кардиология</li>
                  <li>Гепатология</li>
                  <li>Нефрология</li>
                  <li>Инфекционные заболевания</li>
                  <li>Неврология</li>
                </ul>
              </div>
              <div className={styles.scheme__right}>
                <div className={styles.scheme__title}>Медтехника</div>
                <ul className={styles.scheme__list}>
                  <li>Медицинская техника для лучевой терапии</li>
                  <li>Системы медицинской визуализации</li>
                  <li>Эндоскопическое оборудование</li>
                  <li>Оборудование для лабораторной диагностики</li>
                  <li>Оборудование, комплексные системы и наборы для генетической диагностики</li>
                  <li>Оборудование для вспомогательных репродуктивных технологий</li>
                  <li>Медицинские информационные системы для хранения и обработки изображений</li>
                  <li>Оборудование для централизованного смешивания и разведения препаратов</li>
                </ul>
              </div>

            </div>
          </div>
        </section>

        <section className={styles.flexible}>
          <div className="container">
            <h2 className={styles.flexible__title}>Мы гибкие</h2>
            <div className={` ${stylesText.paragraph} ${stylesText.paragraph_about} ${stylesText.lid}  ${styles.paragraph_5} `} data-animate={'fade-in-up'}>
              <p>Умеем подстраиваться под обстоятельства и меняться. Например, во время пандемии ковида организовали удаленку и гибкий офис. Это открыло новые возможности для Р‑Фарм и сотрудников: теперь мы нанимаем людей по всей России. А ещё одними из первых взялись за производство вакцины, чтобы отвечать изменившимся потребностям рынка.</p>
              <p className={stylesText.lid}>Сегодня работаем над вводом и локализацией аналогов зарубежных препаратов. Тех, что нужны здесь и сейчас, чтобы заместить выпадающие с рынка иностранные препараты.</p>
            </div>
          </div>
          <div className={styles.sticky}>
            <Sticky height={'200vh'} data-animate={'fade-in-up'}>
              <StickyGallery>
                <div className={styles.sticky__gallery}>
                  <div className={styles.sticky__col}>
                    <Photo img={'about-photo-1'} label={true} title={'622'} subtitle={'новых рабочих места в среднем\nсоздается в Р‑Фарм каждый год'} use={'about'} />
                  </div>
                  <div className={styles.sticky__col}>
                    <Photo img={'about-photo-2'} label={true} title={'~80%'} subtitle={'действующих сотрудников готовы рекомендовать Р‑Фарм в качестве работодателя своим друзьям, знакомым и родственникам'} use={'about'} />
                  </div>
                  {/* <div className={styles.sticky__col}>
                    <Photo img={'about-photo-3'} label={true} title={'Лидер'} subtitle={'среди российских фармкомпаний в рейтинге «50 лучших работодателей России»,\n'} link={['по версии Forbes.Russia', 'https://www.forbes.ru/biznes/447503-lucsie-rabotodateli-rossii-2021-rejting-forbes']} use={'about'} />
                  </div> */}
                </div>
              </StickyGallery>
            </Sticky>
          </div>
        </section>

        <section className={styles.love} ref={refLove}>
          <div className="container">
            <h2>Любим людей</h2>
            <div className={styles.love__list}>
              <div className={styles.love__item} data-animate={'fade-in-up'}>
                <div className={styles.love__img}>
                  <img src={`${path}/img/about-love-1.svg`} alt="" />
                </div>
                <div className={styles.love__info} data-animate={'fade-in-up'}>
                  <h3 className={styles.love__name}>Человечность</h3>
                  <div className={styles.love__text}>Человеческое общение и внимание к личности важны для Р‑Фарм не только на словах. Это основа всех коммуникаций компании. Как и бережная рабочая среда.</div>
                  <div className={`${styles.love__status} ${stylesText.lid}`}>
                    <span className={styles.love__span} data-animate={'rotate-in'} data-animate-offset={'0%'}>Любим людей,</span> <span data-animate={'rotate-in'} data-animate-offset={'0%'} data-animate-delay={'0.1'}>а не иерархии</span>
                  </div>
                </div>
              </div>

              <div className={styles.love__item} data-animate={'fade-in-up'}>
                <div className={styles.love__img}>
                  <img src={`${path}/img/about-love-2.svg`} alt="" />
                </div>
                <div className={styles.love__info} data-animate={'fade-in-up'}>
                  <h3 className={styles.love__name}>Минимум бюрократии</h3>
                  <div className={styles.love__text}>Для быстрой, комфортной и разумной работы каждого члена команды.</div>
                  <div className={`${styles.love__status} ${stylesText.lid}`}>
                    <span className={styles.love__span} data-animate={'rotate-in'} data-animate-offset={'0%'}>Помогаем реализовывать</span>
                    <span className={styles.love__span} data-animate={'rotate-in'} data-animate-offset={'0%'} data-animate-delay={'0.1'}>инициативы,</span>
                    <span data-animate={'rotate-in'} data-animate-offset={'0%'} data-animate-delay={'0.2'}> а не создаем</span>
                    <span data-animate={'rotate-in'} data-animate-offset={'0%'} data-animate-delay={'0.3'}>препятствия</span>
                  </div>
                </div>
              </div>
              <div className={styles.love__item} data-animate={'fade-in-up'}>
                <div className={styles.love__img}>
                  <img src={`${path}/img/about-love-3.svg`} alt="" />
                </div>
                <div className={styles.love__info} data-animate={'fade-in-up'}>
                  <h3 className={styles.love__name}>Высокие стандарты этики бизнеса</h3>
                  <div className={styles.love__text}>Поддерживаем высокие стандарты деловых отношений и коммуникации. Следуем правилам цивилизованного ведения бизнеса и нулевой терпимости к любым проявлениям коррупции.</div>
                  <div className={`${styles.love__status} ${stylesText.lid}`}>
                    <span className={styles.love__span} data-animate={'rotate-in'} data-animate-offset={'0%'}>Прозрачно,</span>
                    <span className={styles.love__span} data-animate={'rotate-in'} data-animate-offset={'0%'} data-animate-delay={'0.1'}>добросовестно</span>
                    <span className={styles.love__span} data-animate={'rotate-in'} data-animate-offset={'0%'} data-animate-delay={'0.2'}>и честно</span>
                    <span data-animate={'rotate-in'} data-animate-offset={'0%'} data-animate-delay={'0.3'}> ведем бизнес</span>
                    <span data-animate={'rotate-in'} data-animate-offset={'0%'} data-animate-delay={'0.4'}> и работаем с людьми</span>
                  </div>
                </div>
              </div>
              <div className={styles.love__item} data-animate={'fade-in-up'}>
                <div className={styles.love__img}>
                  <img src={`${path}/img/about-love-4.svg`} alt="" />
                </div>
                <div className={styles.love__info} data-animate={'fade-in-up'}>
                  <h3 className={styles.love__name}>Развитие молодых талантов</h3>
                  <div className={styles.love__text}>
                    <p>Уделяем особое внимание развитию образовательных и профориентационных проектов для школьников и студентов.</p>
                    <p>Первыми в фармотрасли выстроили непрерывную систему подготовки кадров: со студенческой скамьи до работы <br/>в Р‑Фарм.</p>
                    <p>Создаем для детей лаборатории, помогаем университетам с оснащением, организуем практики и стажировки.</p>
                  </div>
                  <div className={`${styles.love__status} ${stylesText.lid}`}>
                    <span className={styles.love__span} data-animate={'rotate-in'} data-animate-offset={'0%'}>Ценим специалистов,</span>
                    <span data-animate={'rotate-in'} data-animate-offset={'0%'} data-animate-delay={'0.1'}>даже если у них нет опыта</span>
                    <span data-animate={'rotate-in'} data-animate-offset={'0%'} data-animate-delay={'0.2'}>работы или он небольшой</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        <div className={styles.final} data-header-trigger={true}>
          <div className="container">
            <div className={styles.invite} data-anchor={'invite'}>
              <Invite color={'green'} form={'full'} use={'about'} title={'Если тоже цените стабильность, гибкость, масштабность и людей'} desc={'И хотите работать в крупном международном фармацевтическом бизнесе, приходите\nв Р‑Фарм'} />
            </div>
            <div className={styles.footer}>
              <Footer color={'white'} />
            </div>
          </div>
        </div>
      </div>
    </>
  );

}

export default About;
